export const getSettingsPath = (path: string, isJCS: boolean, helpCenterId?: string): string => {
	if (!helpCenterId) {
		return isJCS ? path.replace('/jira/servicedesk/', '/jira/helpcenter/') : path;
	}
	return path
		.replace('/jira/servicedesk/', '/jira/helpcenter/')
		.replace('/settings', `/settings/${helpCenterId}`);
};
